<template lang="pug">
div
  v-menu(v-model="show" rounded="lg" :close-on-content-click="false" allow-overflow offset-y bottom max-width="580" max-height="345")
    template(#activator="{ on }")
      v-sheet.text-sm.round-lg.clickable.border-menu(flat outlined @click="onClickMenu")
        v-row.py-1(no-gutters align="center" style="min-height: 38px;")
          v-col.pl-3
            .text-sm(v-if="selectedItem") {{ selectedItem.name }}
            .text-sm(v-else-if="parentMedication") {{ parentMedication.name }}
            .text-sm.neutral500--text(v-else) Select medication
          v-col.shrink.pr-4(v-if="isFetching")
            v-progress-circular.ma-auto(:width="2" :size="15" color="primary" indeterminate)
          v-col.shrink.pr-4(v-else)
            v-icon(size=20 style="margin-top: 2px;") $yzi-chevron-down

    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="itemName" outlined :placeholder="$t('search_or_add_new')" dense hide-details autofocus)
        v-divider
      div.d-flex.justify-center(v-if="isFetching")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      .d-flex.align-center.justify-space-between.px-4.py-3
        .font-semibold.mr-6 Existing treatments
        y-pagination(v-model="page" :pageSize="pageSize" :count="count" :loading="isFetching") 
      div(v-for="item in medications" @click="onSelectItem(item)")
        .d-flex.flex-column.py-3.px-4.clickable.hover-bg
          .text-sm.font-normal(v-if="item.uom") {{ item.name }}  ({{item.uom}})
          .text-sm.font-normal(v-else) {{ item.name }}
          .d-flex
            .d-flex.align-center.mr-4
              template(v-if="hasStock(item)")
                v-icon.mr-1(size="11" color="success") $yzi-circle
                .text-xs.font-normal.neutral500--text {{ $t('in_stock') }}
              template(v-else)
                v-icon.mr-1(size="11" color="danger") $yzi-circle
                .text-xs.font-normal.neutral500--text {{ $t('out_of_stock') }}
            .d-flex.align-center.mr-4
              v-icon.mr-1(size="13") $yzi-colors
              .text-xs.font-normal.neutral500--text Medication
            template(v-if="item.groups && item.groups.length > 0")
              .d-flex.align-center.mr-4
                v-icon.mr-1(size="13") $yzi-folder
                .text-xs.font-normal.neutral500--text {{ item.groups.join(', ') | capitalize }}
          .text-xxs.font-normal.italic.danger500--text(v-if="item.hasError") {{ item.errorMessage }}
        v-divider
      template(v-if="!medications.length")
        .px-4.py-3 {{ $t('no_result_match') }}
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    parentMedication: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    isLoading: false,
    isFetching: false,
    show: false,
    itemName: '',
    selectedItem: null,
    page: 1,
    pageSize: 10,
    count: 0,
    medications: [],
    initialized: false,
    noSearch: false
  }),
  computed: {
    ...mapGetters({ company: 'getCompany' })
  },
  watch: {
    show(val) {
      this.$emit('dropdownOpenClosed', val)
    },
    page () {
      this.fetchMedications()
    },
    itemName () {
      if (this.noSearch) return

      this.searchStart()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    searchStart: debounce(function () {
      this.page = 1
      this.fetchMedications()
    }, 750),
    onSelectItem (item) {
      this.selectedItem = item
      this.show = false
      this.$emit('changed', this.selectedItem)
    },
    async fetchMedications () {
      if (this.show && !this.initialized) {
        this.show = false
      }
      try {
        this.isFetching = true
        let params = {
          page: this.page,
          page_size: this.pageSize,
          search: this.itemName || null,
          status: 'published'
        }
        const { data } = await this.$axios.get(`/clinics/${this.company.slug}/medications`, { params })
        if (data.count > 0) {
          const newData = data.results.map(result => {
            return {
              ...result,
              groups: result.groups.map(group => group.value),
            }
          })
          this.medications = newData
        } else {
          this.medications = []
        }
        this.count = data.count
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isFetching = false
        this.show = true
        this.initialized = true
        this.noSearch = false
      }
    },
    hasStock(item) {
      if (!item.product.inventory_enabled) {
        return true
      }
      if (item.product.inventory_qty > 0) {
        return true
      }
      return false
    },
    onClickMenu () {
      if (this.itemName.length > 0) {
        this.itemName = ''
        this.noSearch = true
      }
      this.fetchMedications()
    }
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.error-border-menu {
  border: 1px solid var(--v-danger500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
.disabled-item {
  background-color: var(--v-neutral300);
  color: var(--v-neutral500);
}
</style>